import { ProductKpi } from '@/domain/products/types';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { Accordion, AccordionSummary } from '@andritzot/metris-web-ui/surfaces/accordion';

interface KpiContentProps {
  productKpi: ProductKpi[];
}

export const KpiContent = ({ productKpi }: KpiContentProps) => {
  const orderedKpi = [...productKpi].sort((a, b) => a.order - b.order);

  return (
    <Box sx={{ backgroundColor: '#fff' }}>
      {orderedKpi.map((kpi) => (
        <Accordion key={kpi.id} defaultExpanded={false} disableGutters>
          <AccordionSummary sx={{ backgroundColor: '#fff', boxShadow: 'none', border: 'none' }} expandIcon="">
            <Typography sx={{ mr: 4 }}>#{kpi.order}</Typography>
            <Typography>{kpi.statement}</Typography>
          </AccordionSummary>
        </Accordion>
      ))}
    </Box>
  );
};
